module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("kKPSO"))).then(() => parcelRequire('5erN3'));